import React from 'react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Our Campus', href: '/our-campus' },
    { name: 'Mission & Vision', href: '/mission-vision' },
    { name: 'Admissions', href: '/coming-soon' },
  ];

  const familyLinks = [
    { name: 'School Calendar', href: 'https://www.schools.nyc.gov/calendar/2026-2027-school-year-calendar' },
    { name: 'NYC Schools Account', href: 'https://www.schoolsaccount.nyc/' },
    { name: 'Parent Handbook', href: '/coming-soon' },
    { name: 'PTA', href: '/coming-soon' },
  ];

  const partnerLinks = [
    { name: 'Beacon', href: 'https://www.scan-harbor.org/our-programs/' },
    { name: 'DMF Youth', href: 'https://dmfyouth.org/' },
    { name: 'Reading Partners', href: 'https://readingpartners.org/' },
    { name: '92nd St. Y', href: 'https://www.92ny.org/' },
  ];

  return (
    <footer className="relative overflow-hidden bg-gray-900">
      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8 lg:py-20">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-4 lg:gap-8">

            {/* School Info */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <img
                  src="/assets/images/general/logo.png"
                  alt="River East Elementary Logo"
                  className="h-12 w-12 brightness-0 invert"
                />
                <div>
                  <h3 className="text-lg font-bold text-white">River East</h3>
                  <p className="text-sm text-cyan-400">Elementary School</p>
                </div>
              </div>
              <p className="text-sm text-white/70 leading-relaxed">
                A small PK3-5th Grade school in East Harlem where every student is known, valued, and inspired.
              </p>
              <div className="mt-6 space-y-2">
                <p className="text-sm text-white/80">
                  <span className="font-semibold text-white">Phone:</span>{' '}
                  <a href="tel:+12128023035" className="hover:text-cyan-400 transition-colors">
                    (212) 802-3035
                  </a>
                </p>
                <p className="text-sm text-white/80">
                  <span className="font-semibold text-white">Address:</span>{' '}
                  <span className="block ml-0 mt-1">2351 1st Avenue<br />New York, NY 10035</span>
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <nav aria-label="Quick links">
              <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm text-white/70 hover:text-cyan-400 transition-colors duration-200 flex items-center gap-2 group"
                    >
                      <span className="h-1 w-1 rounded-full bg-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity" />
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* For Families */}
            <nav aria-label="Family resources">
              <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">For Families</h3>
              <ul className="space-y-3">
                {familyLinks.map((link) => {
                  const isExternal = link.href.startsWith('http');
                  return (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
                        className="text-sm text-white/70 hover:text-cyan-400 transition-colors duration-200 flex items-center gap-2 group"
                      >
                        <span className="h-1 w-1 rounded-full bg-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity" />
                        {link.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </nav>

            {/* Partners */}
            <nav aria-label="Partner links">
              <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">Our Partners</h3>
              <ul className="space-y-3">
                {partnerLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-white/70 hover:text-cyan-400 transition-colors duration-200 flex items-center gap-2 group"
                    >
                      <span className="h-1 w-1 rounded-full bg-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity" />
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10">
          <div className="mx-auto max-w-7xl px-6 py-6 lg:px-8">
            <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
              <p className="text-xs text-white/60 text-center sm:text-left">
                &copy; {new Date().getFullYear()} River East Elementary School (PS 37). All rights reserved.
              </p>
              <a
                href="#main-content"
                className="text-xs font-semibold text-cyan-400 hover:text-cyan-300 transition-colors"
              >
                Back to Top ↑
              </a>
            </div>

            {/* NexSav Credit */}
            <div className="mt-4 pt-4 border-t border-white/5">
              <a
                href="https://nexsav.net"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-white/60 hover:text-white/90 transition-all duration-300 group"
              >
                <img
                  src="https://nexsav.net/static/media/logo.7ef8f9a8ca3ec946bd31.png"
                  alt="NexSav Logo"
                  className="h-5 opacity-60 group-hover:opacity-90 transition-opacity duration-300"
                />
                <span className="text-xs font-medium tracking-wide">
                  Website designed & developed by <span className="font-semibold">NexSav</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
